export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/ce96810bf4c22da582d7.worker.js");
}
